// /var/www/afra/web-design.rampagesoft.com/my-app/src/footer.js
import React, { useState } from 'react';
import footerData from './data/footerData.json';
import 'primeicons/primeicons.css';
import './css/footer.scss';

/* 4 logical sections used by the dropdown logic */
const SECTIONS = ['footerLinks', 'services', 'articles', 'contacts'];

const Footer = () => {
  const [openDropdown, setOpenDropdown] = useState(null);

  /* one set of inline-styles per dropdown block (mobile only) */
  const [dropdownStyles, setDropdownStyles] = useState(
    SECTIONS.reduce((acc, key) => {
      acc[key] = {
        transform : 'translateY(-10px)',
        opacity   : 0,
        maxHeight : '0px',
        transition: 'transform .4s ease, opacity .4s ease, max-height .4s ease',
      };
      return acc;
    }, {})
  );

  const toggleDropdown = (section) =>
    setOpenDropdown((prev) => {
      const opening = prev !== section;
      setDropdownStyles((s) => ({
        ...s,
        [section]: {
          ...s[section],
          transform : opening ? 'translateY(0)' : 'translateY(-10px)',
          opacity   : opening ? 1              : 0,
          maxHeight : opening ? '500px'        : '0px',
        },
      }));
      return opening ? section : null;
    });

  /* helpers */
  const renderLinks = (arr) =>
    arr.map((l, i) => (
      <li key={i}>
        <a href={l.url}>{l.name}</a>
      </li>
    ));

  const renderContacts = (arr) =>
    arr.map((c, i) => (
      <li key={i}>
        <a href={c.url}>
          <i className={c.icon}></i> <span className="text">: {c.text}</span>
        </a>
      </li>
    ));

  /* ─────────────────────────────────────────── */
  return (
    <footer>
      <section
        className="footer__area-common footer__area-common-2 theme-bg-2"
        data-background="assets/imgs/footer/footer-bg-2.svg"
      >
        <div className="container">
          <div className="footer__main">
            {/* ONE ROW → FOUR COLUMNS ON DESKTOP */}
            <div className="row">

              {/* ① COMPANY (with internal mobile-dropdown) */}
              <div className="col-xl-3 col-lg-3 col-md-6 footer__pad">
                <div className="footer__widget-title">
                  <div className="footer__widget-title-mobile">
                    <h4>{footerData.companyInfo.title}</h4>
                  </div>
                  <h4 className="footer__widget-title-pc">
                    {footerData.companyInfo.title}
                  </h4>
                </div>

                <div className="footer__content-body">
                  <div className="row footer__address">
                    <div className="col-6">
                      <p>{footerData.companyInfo.addresses[0]}</p>
                    </div>
                    <div className="col-6">
                      <p>{footerData.companyInfo.addresses[1]}</p>
                    </div>
                  </div>
                  <p>{footerData.companyInfo.description}</p>
                </div>

                {/* mobile dropdown for “About Company” links */}

                <div className="footer__widget-title">
                <div
                  className={`footer__widget-title-mobile ${
                    openDropdown === 'footerLinks' ? 'open' : ''
                  }`}
                  onClick={() => toggleDropdown('footerLinks')}
                >
                  
                  <button className="dropdown-toggle">
                    About Company <i className="pi pi-angle-down"></i>
                  </button>
                  <div
                    className="dropdown-content"
                    style={dropdownStyles.footerLinks}
                  >
                    <ul>{renderLinks(footerData.footerLinks)}</ul>
                  </div>
                </div>
                </div>

                {/* desktop static list */}
                <div className="footer__link dis-footer">
                  <ul>{renderLinks(footerData.footerLinks)}</ul>
                </div>

                <div className="footer__social footer__social-md social-border-top mt-30 pt-30 posi-footer">
                  {footerData.socialMedia.map((s) => (
                    <a
                      key={s.name}
                      href={s.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className={s.icon}></i>
                    </a>
                  ))}
                </div>
              </div>

              {/* ② SERVICES */}
              <div className="col-xl-3 col-lg-3 col-md-6 footer__pad">
                <div className="footer__widget-title">
                  <div
                    className={`footer__widget-title-mobile ${
                      openDropdown === 'services' ? 'open' : ''
                    }`}
                    onClick={() => toggleDropdown('services')}
                  >
                    <button className="dropdown-toggle">
                      {footerData.servicesTitle}{' '}
                      <i className="pi pi-angle-down"></i>
                    </button>
                    <div
                      className="dropdown-content"
                      style={dropdownStyles.services}
                    >
                      <ul>{renderLinks(footerData.services)}</ul>
                    </div>
                  </div>
                  <h4 className="footer__widget-title-pc">
                    {footerData.servicesTitle}
                  </h4>
                </div>
                <div className="footer__link">
                  <ul>{renderLinks(footerData.services)}</ul>
                </div>
              </div>

              {/* ③ CONTENT */}
              <div className="col-xl-3 col-lg-3 col-md-6 footer__pad">
                <div className="footer__widget-title">
                  <div
                    className={`footer__widget-title-mobile ${
                      openDropdown === 'articles' ? 'open' : ''
                    }`}
                    onClick={() => toggleDropdown('articles')}
                  >
                    <button className="dropdown-toggle">
                      {footerData.articlesTitle}{' '}
                      <i className="pi pi-angle-down"></i>
                    </button>
                    <div
                      className="dropdown-content"
                      style={dropdownStyles.articles}
                    >
                      <ul>{renderLinks(footerData.articles)}</ul>
                    </div>
                  </div>
                  <h4 className="footer__widget-title-pc">
                    {footerData.articlesTitle}
                  </h4>
                </div>
                <div className="footer__link">
                  <ul>{renderLinks(footerData.articles)}</ul>
                </div>
              </div>

              {/* ④ CONTACTS */}
              <div className="col-xl-3 col-lg-3 col-md-6 footer__pad">
                <div className="footer__widget-title">
                  <div
                    className={`footer__widget-title-mobile ${
                      openDropdown === 'contacts' ? 'open' : ''
                    }`}
                    onClick={() => toggleDropdown('contacts')}
                  >
                    <button className="dropdown-toggle">
                      {footerData.contactsTitle}{' '}
                      <i className="pi pi-angle-down"></i>
                    </button>
                    <div
                      className="dropdown-content"
                      style={dropdownStyles.contacts}
                    >
                      <ul>{renderContacts(footerData.contacts)}</ul>
                    </div>
                  </div>
                  <h4 className="footer__widget-title-pc">
                    {footerData.contactsTitle}
                  </h4>
                </div>
                <div className="footer__link">
                  <ul>{renderContacts(footerData.contacts)}</ul>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* COPYRIGHT BAR */}
        <div className="footer__bottom-wrapper">
          <div className="container">
            <div className="footer__bottom">
              <div className="footer__copyright">
                <p>
                  {footerData.copyright.text}{' '}
                  <a href={footerData.copyright.links[0].url}>
                    {footerData.copyright.links[0].name}
                  </a>{' '}
                  {footerData.copyright.yearRange}{' '}
                  {footerData.copyright.suffix}{' '}
                  <a href={footerData.copyright.links[1].url}>
                    {footerData.copyright.links[1].name}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
